import { widgetState } from '../store/customizations/index'
import { SellingPlanGroup } from './selling-plan-group'

export type DiscountType = 'percentage' | 'fixed_amount'

export interface PriceAdjustment {
  valueType: DiscountType
  value: number
}

export function getPriceAdjustmentValueType (priceAdjustment: PriceAdjustment, currencySymbol: string): string | undefined {
  if (priceAdjustment) {
    return priceAdjustment.valueType === 'fixed_amount' ? currencySymbol : '%'
  }
}

export function getPriceAdjustmentValue (priceAdjustment: PriceAdjustment): number | undefined {
  if (priceAdjustment) {
    return priceAdjustment.valueType === 'percentage' ? priceAdjustment.value : priceAdjustment.value * 0.01
  }
}

export function getPriceAdjustmentLabel (priceAdjustment: PriceAdjustment, currrencySymbol: string): string {
  if (priceAdjustment) {
    const priceAdjustmentType = getPriceAdjustmentValueType(priceAdjustment, currrencySymbol)
    const priceAdjustmentValue = getPriceAdjustmentValue(priceAdjustment)
    if (priceAdjustmentType === currrencySymbol) {
      return `${priceAdjustmentType}${priceAdjustmentValue}`
    }
    if (widgetState.customizations.priceLabel.percentSymbolLocation === 'left') {
      return `${priceAdjustmentType}${priceAdjustmentValue}`
    }
    return `${priceAdjustmentValue}${priceAdjustmentType}`
  }
}

export function sortPriceAdjustments (sellingPlanGroups: SellingPlanGroup[], selectedGroupId: string, price: number): PriceAdjustment[] {
  const selectedSellingPlanGroup = sellingPlanGroups.find(group => group.id === selectedGroupId)

  if (selectedSellingPlanGroup) {
    const priceAdjustments: PriceAdjustment[] = selectedSellingPlanGroup.sellingPlans
      .filter(plan => plan.priceAdjustments && plan.priceAdjustments.length > 0)
      .map(plan => {
        return plan.priceAdjustments[0]
      })
      .sort((plan1, plan2) => {
        return getValue(plan1.value, plan1.valueType, price) - getValue(plan2.value, plan2.valueType, price)
      })

    return priceAdjustments.length > 0 ? priceAdjustments : [{ valueType: 'fixed_amount', value: 0 }]
  }

  return []
}

const getValue = (value: number, type: DiscountType, price: number): number => {
  if (type === 'fixed_amount') {
    return price - value
  }
  return price - (price * (value / 100))
}
